import React, { useEffect, useState } from 'react'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box, Button, Checkbox, FormControlLabel, Grid, LinearProgress, Stack, Step, StepLabel, Stepper, Typography
} from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import stylesheet from '../patients/detail/detail-container.stylesheet';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { toast } from 'react-toastify'
import Helper from './helper'
import { TaskService } from './tasks.service'
import CallIcon from '@mui/icons-material/Call'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import moment from 'moment'
import EmptyCardComponent from '../patients/detail/common/empty-card.component'

interface IProps {
	input: any
	updateIsTaskUpdate?: any
	classes: ClassNameMap
}

const TaskHistoryComponent: React.FC<IProps> = ({ input, updateIsTaskUpdate, classes }) => {
	const [historyLoading, setHistoryLoading] = useState(false) as any
	const [isActionCall, setIsActionCall] = useState(false) as any;
	const [historyData, setHistoryData] = useState({}) as any
	const [historyAllData, setHistoryAllData] = useState({}) as any
	const taskService = new TaskService();

	useEffect(() => {
		if (!historyLoading)
			getTaskHistory()

		if (input.isTaskUpdate)
			updateIsTaskUpdate(true)
	}, [input.patientId, input.isTaskUpdate])

	const updateDataByActionType = (histortData: any, type = 'Call') => {
		let newActionObj = {} as any
		if (type === 'Call') {
			Object.keys(histortData).map((i: any) => {
				let actionData = histortData[i]?.filter((k: any) => k.task?.action_type === type
					&& !(k.message).toLowerCase().includes('added a note')
					&& ((k.message).toLowerCase().includes('completed') || (k.message).toLowerCase().includes('attempted'))
				)
				if (actionData?.length > 0)
					newActionObj = { ...newActionObj, [i]: actionData }
			})
			setHistoryData(newActionObj)
		} else {
			setHistoryData(histortData)
		}
	}

	const getTaskHistory = () => {
		setHistoryLoading(true)
		if (input.task_id) {
			taskService.getTaskHistoryById(input.patientId, input?.task_id || '').then((res: any) => {
				setHistoryData((res?.data?.history) ? res?.data?.history : {})
				setHistoryLoading(false)
			}).catch((err: any) => {
				setHistoryData({})
				setHistoryLoading(false)
				toast.error(Helper.getError(err), Helper.bottom_center())
			})
		} else {
			taskService.getTaskHistory(input.patientId).then((res: any) => {
				if (res?.data?.history) {
					setHistoryAllData(res?.data?.history)
					updateDataByActionType(res?.data?.history, isActionCall ? 'Call' : 'All')
				} else
					resetHistory()
				setHistoryLoading(false)
			}).catch((err: any) => {
				resetHistory()
				setHistoryLoading(false)
				toast.error(Helper.getError(err), Helper.bottom_center())
			})
		}
	}

	const resetHistory = () => {
		setHistoryData({})
		setHistoryAllData({})
	}
	const CustomStepIcon = (type: any, message: any) => {
		return (
			<Button variant="outlined"
				sx={{
					minWidth: 0,
					width: '0.7rem !important',
					height: '0.7rem !important',
					backgroundColor: message.includes('completed')
						? '#36b036 !important'
						: (message).includes('attempted')
							? 'orange !important'
							: 'grey !important',
					borderColor: message.includes('completed')
						? '#36b036 !important'
						: (message).includes('attempted')
							? 'orange !important'
							: 'grey !important',
					padding: '0px !important',
					marginTop: '0.1rem',
					cursor: 'default'
				}}>
				{type === 'Call'
					? <CallIcon
						sx={{
							fontSize: '0.5rem !important',
							transform: 'rotate(16deg) !important',
							fill: '#FFF',
						}} />
					:
					<FormatListBulletedIcon
						sx={{
							fontSize: '0.5rem !important',
							fill: '#FFF',
						}} />
				}
			</Button>
		)
	};

	const getEventList = (data: any, type: any) => {
		return <Accordion square defaultExpanded={true} className={classes.patientAccrodionBg}
			sx={{
				backgroundColor: input?.isTaskPanel ? 'var(--color-body-background)' : 'var(--color-paper) !important',
				padding: '0rem',
				marginBottom: '0.3rem'
			}}>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon className={classes.patientAccrodionExpandIcon} />}
				sx={{
					backgroundColor: 'var(--color-background-subtle)', borderRadius: '0.2rem', padding: '0rem 0.2rem !important',
					//height: '1rem',
				}}
			>
				<Grid container justifyContent="space-between" alignItems="center">
					<Grid item xs={8}>
						<Typography variant="subtitle2" className={classes.desc}>
							{moment(type).format('DD MMM  YYYY')}
						</Typography>
					</Grid>
					<Grid item xs>
						{data.length > 0 &&
							<Typography align="right" variant="subtitle2" className={classes.desc}>
								{moment.unix(data[0].timestamp).fromNow()}
							</Typography>
						}
					</Grid>
				</Grid>
			</AccordionSummary>
			<AccordionDetails sx={{
				'&.MuiAccordionDetails-root': {
					padding: '0px 0px 2px 5px !important',
				}
			}}>
				<Box className={classes.fullWidth} >
					<Stepper orientation="vertical" sx={{
						paddingTop: '0.2rem !important',
						'.MuiStepConnector-root': {
							display: "none !important"
						},
						'.MuiStepLabel-root': {
							padding: '0px !important'
						}
					}}>
						{[...data]?.sort((a: any, b: any) => a.timestamp < b.timestamp ? 1 : -1)
							?.map((item: any, index: any) => {
								return <Step key={`${item.timestamp}-${index}`} active expanded
									sx={{
										'.MuiStepContent-root, .MuiStepConnector-line ': {
											borderLeft: `0.12rem solid ${item.message.includes('completed')
												? '#36b036 !important'
												: (item.message).includes('attempted')
													? 'orange !important'
													: 'grey !important'
												}`
										},
									}}
								>
									<StepLabel StepIconComponent={() => CustomStepIcon(item?.task?.action_type, item?.message)}
										sx={{
											'.MuiStepLabel-labelContainer': {
												backgroundColor: 'var(--color-background-subtle)',
												borderRadius: '0.2rem',
												padding: '0rem 0.2rem 0rem 0rem !important',
											},
										}}>
										<Grid container spacing={0.2} className={classes.compactCardContent}
											alignItems={'baseline'} direction="row" justifyContent="space-between">
											<Grid item xs className={classes.zeroTopPadding}>
												<Typography component={'span'} variant="body2" className={classes.desc}>
													{item?.task?.title}
												</Typography>
												<Typography component={'span'} variant="body2" className={classes.desc}>
													{` - `}{item?.message || ''}
												</Typography>
											</Grid>
											<Grid item sx={{ minWidth: '10%', width: 'fit-content !important' }}>
												<Typography variant="body1" textAlign={'right'} className={classes.desc}>
													<small>{moment.unix(item.timestamp).format('hh:mm a')}</small>
												</Typography>
											</Grid>
										</Grid>
									</StepLabel>
									<Box sx={{
										borderLeft: `0.12rem solid ${item.message.includes('completed')
											? '#36b036 !important'
											: (item.message).includes('attempted')
												? 'orange !important'
												: 'grey !important'
											}`,
										margin: '0rem 0.5rem 0.2rem 0.3rem',
									}}>
										{item?.note &&
											<Typography pl={2} variant="body2" className={classes.desc}>
												{item?.note || ''}
											</Typography>
										}
									</Box>
								</Step>
							})}
					</Stepper>
				</Box>
			</AccordionDetails>
		</Accordion>
	}

  if (input?.isTaskEdit && !historyLoading && Object.keys(historyAllData).length === 0) return null

  const content = (
    <Box
      sx={{
        height: input?.isTaskPanel ? 'inherit' : !input?.isTaskEdit ? '31rem' : 'unset',
        maxHeight: input?.isTaskEdit ? '22rem' : 'unset',
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      {historyLoading && !input?.isTaskEdit && <LinearProgress />}
      <Box sx={{ padding: input?.isTaskPanel ? '0rem 0.2rem' : !input?.isTaskEdit ? '0rem 2rem 0.5rem 1.5rem' : '' }}>
        {!input?.isTaskEdit && Object.keys(historyAllData)?.length > 0 && (
          <Stack direction={'row'} justifyContent={'space-between'} sx={{ padding: '0.5rem 0rem 0.5rem 0.5rem' }}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  sx={{ padding: '0rem !important', transform: 'scale(0.6)' }}
                  checked={isActionCall}
                  onChange={(e) => {
                    setIsActionCall(!isActionCall)
                    updateDataByActionType(historyAllData, !isActionCall ? 'Call' : 'All')
                  }}
                />
              }
              label={<Typography className={classes.desc} variant="body2">{'Calls'}</Typography>}
              aria-setsize={10}
            />
          </Stack>
        )}
        {Object.keys(historyData)?.map((i: any) => getEventList(historyData[i], i))}
        {(input.isPatientTaskList || !input?.isTaskEdit) && !historyLoading && Object.keys(historyData)?.length <= 0 && (
          <Box pt={2}><EmptyCardComponent /></Box>
        )}
      </Box>
    </Box>
  )

  if (input?.isTaskEdit) {
    return (
      <>
        <Stack direction="row" alignItems="center" spacing={0.7} sx={{ mb: 0.6 }}>
          <Typography sx={{ fontSize: '0.65rem', fontWeight: 700, color: 'var(--color-primary)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            Tasks &amp; Activity
          </Typography>
          <Box sx={{ flex: 1, height: '1px', background: '#F0642330' }} />
        </Stack>
        <Box sx={{ borderRadius: '12px', background: '#fff8f414', border: '1.5px solid #F0642322', borderLeft: '4px solid var(--color-primary)', boxShadow: '0 2px 8px #F0642310', padding: '0.5rem 0.8rem' }}>
          {content}
        </Box>
      </>
    )
  }

  return content
}

export default withStyles(stylesheet)(TaskHistoryComponent)